import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {CreateScheduleOneOffInput, ScheduleRepository} from '../ports/schedule.repository';

export class CreateScheduleOneOff implements UseCase<[CreateScheduleOneOffInput], void> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(input: CreateScheduleOneOffInput): Promise<Result<void, ScheduleError>> {
    return this.repository.createOneOff(input);
  }
}
